module.exports = __webpack_public_path__ + "img/przedszkole2.f1e51d89.jpg";